import { useCallback } from "react";
import { useMISReportDownload } from "@hooks/useMISReportDownload";
import { MIS_FIELDS_OTAPARTNER } from "@constants/misDownloadData";
import { ATP_API_URL } from "@config/apiconfig";

export const useOtaPartnerDownload = () => {
  const dataMapper = useCallback(
    (item) => ({
      "Sr No": item.sr_no,
      "Partner Name": item.partner_name || "-",
      Date: item.date || "-",
      Searches: item.searches || "-",
      "Eligible Policies Shown": item.eligible_policies_shown || "-",
      "Policies Sold": item.policies_sold || "-",
      "Conversion %": item.conversion_percentage || "-",
      "Total Premium (₹)": item.total_premium || "-",
      "Claims Count": item.claims_count || "-",
      "Claim Ratio (%)": item.claim_ratio || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "ota-partner",
    reportName: "OTA Partner Insurance",
    fields: MIS_FIELDS_OTAPARTNER,
    dataMapper,
    apiUrl: ATP_API_URL.MIS_OTA_PARTNER,
    sheetName: "OTA Partner",
  });
};

export default useOtaPartnerDownload;
